import React from "react";
import { CardContainer } from "../../../components/Card";
import { BarChart, LineChart } from "../../../components/Charts";

export default function YoutubeTab({ data }) {
    return (
        <>
            <CardContainer>
                <LineChart
                    data={data}
                    series={[
                        {
                            name: "Youtube",
                            key: "ttt_youtube",
                        },
                    ]}
                    xKey="week"
                    title="TTT Youtube Subscribers"
                />
                <BarChart
                    data={data?.map((d) => ({
                        ...d,
                        ttt_youtube_change: d.ttt_youtube_change * 100,
                    }))}
                    series={[
                        {
                            name: "Youtube Subscribers",
                            key: "ttt_youtube_change",
                        },
                    ]}
                    xKey="week"
                    title="TTT Youtube Subscribers % Change"
                    yFormatter={(v) => `${v / 100}`}
                />
            </CardContainer>
            <CardContainer>
                <LineChart
                    data={data}
                    series={[
                        {
                            name: "Youtube",
                            key: "dobara_youtube",
                        },
                    ]}
                    xKey="week"
                    title="Dobara Youtube Subscribers"
                />
                <BarChart
                    data={data?.map((d) => ({
                        ...d,
                        dobara_youtube_change: d.dobara_youtube_change * 100,
                    }))}
                    series={[
                        {
                            name: "Youtube Subscribers",
                            key: "dobara_youtube_change",
                        },
                    ]}
                    xKey="week"
                    title="Dobara Youtube Subscribers % Change"
                    yFormatter={(v) => `${v / 100}`}
                />
            </CardContainer>
        </>
    );
}
